import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/student-education-levels/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const studentEducationLevel = {
  getAll: apiPathFunc(pathBase),
} as const;
